(function () {
  // Mobile only
  if (!window.matchMedia("(max-width: 749px)").matches) return;

  // Hide on load
  document.body.classList.add("filters-hidden-on-load");

  // Reveal after user starts scrolling
  var revealAt = 180; // adjust if you want (ex: 80, 120, 250)

  function onScroll() {
    if (window.scrollY > revealAt) {
      document.body.classList.remove("filters-hidden-on-load");
      window.removeEventListener("scroll", onScroll);
    }
  }

  window.addEventListener("scroll", onScroll, { passive: true });
})();
